import * as yup from 'yup';

import { LoginFormField } from '../types';

export const loginValidationSchema = yup.object({
  [LoginFormField.verificationCode]: yup
    .string()
    .typeError('Required')
    .required('Verification Code is required'),
});
